import { ReactNode } from "react";
import classnames from "classnames";

interface Props {
  flag?: "success" | "info" | "warning" | "danger" | string;
  children?: ReactNode;
}

export const Flag = ({ flag = "success", children }: Props) => {
  return <div className={classnames("flag", flag)}>{children}</div>;
};
